import { mapGetters } from 'vuex';

import PzButton from '@/components/PzButton.vue';
import EmptyList from '@/views/Events/components/EmptyList.vue';
import EventListInPanel from '@/views/Events/components/EventListInPanel.vue';

export default {
  name: 'LatestPaperList',

  components: {
    PzButton,
    EmptyList,
    EventListInPanel,
  },

  props: {
    openSelectableModal: {
      type: Function,
      default: () => null,
    },

    go2MockWithPaper: {
      type: Function,
      default: () => null,
    },
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters('Events', {
      mg_InProgressList: 'InProgressList',
      mg_ReadyToStartList: 'ReadyToStartList',
      mg_selectedInProgressList: 'selectedInProgressList',
      mg_selectedReadyToStartList: 'selectedReadyToStartList',
    }),

    c_latestEventList() {
      return [...this.mg_InProgressList, ...this.mg_ReadyToStartList];
    },
  },
};
